import React from "react";

const Washing_24 = React.forwardRef(
  ({ width = "32", height = "32", viewBox = "0 0 32 32", fill = "none", className }, ref) => {
    return (
      <svg
        ref={ref}
        {...{ width, height, viewBox, fill, className }}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0V32H32V0H0ZM30 2H18.1538L2 17.8934V30H30V2ZM10.8656 2H13.8762L2 13.6848V10.7227L10.8656 2ZM6.58805 2H2V6.51409L6.58805 2Z"
          fill="black"
        />
      </svg>
    );
  },
);

export default Washing_24;
